export const USER_PROFILE_DRAWER_KEY = Symbol("userProfileDrawer");

export { default as UserProfileDrawer } from "./ui/UserProfileDrawer.vue";
